(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spur-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sp-filter]').forEach(function (group) {
    var grid = document.getElementById(group.getAttribute('data-sp-filter'));
    if (!grid) return;
    var buttons = group.querySelectorAll('button[data-filter]');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var filter = button.getAttribute('data-filter');
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === button ? 'true' : 'false'); });
        grid.querySelectorAll('.sp-card').forEach(function (card) {
          var gender = card.getAttribute('data-gender');
          card.hidden = !(filter === 'all' || gender === filter || gender === 'unisex');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
